import {OrderDiscountCode} from '@/api/models'

export const doesDiscountCodeApply = ({product_type, products_ids}: OrderDiscountCode, groupID?: number) =>
  !product_type ||
  (product_type === 'support_group' &&
    (!products_ids.length || products_ids.some((id) => id === groupID?.toString())))
